// extracted by mini-css-extract-plugin
export default {"tableHeaderCell":"AreaTable_tableHeaderCell__lfTHu","tableRowEven":"AreaTable_tableRowEven__MmHWZ","tableRowOdd":"AreaTable_tableRowOdd__vk6yJ"};